import * as constants from '../constants/jobDetails-constants'
import {
    JobDetailsActions,
    PublishedJobParamsAction
} from '../actions/setJobDetails'
import { JobItems, ComplimentsNumber, Slots, Bid, Job } from '../types'
import { AdditionalItem } from '../types/AdditionalItem'

export interface JobDetailsState {
    address: any
    jobCategoryId: string
    jobCategoryName: string
    msaId: string
    note: string
    jobItems: JobItems[] | null
    areItemsOutside: boolean
    areItemsInside: boolean
    amount: number
    isElevatorNeeded: boolean
    areStairsNeeded: boolean
    jobCategories: Array<any>
    selectedJobCategory: string
    subCategories: Array<any>
    attachments: Array<any> | null
    futureDateFrom: any
    futureDateTo: any
    time: {
        time: number
        futureTime: number
        isFuture: number
        minTime: number
    }
    jobId: string
    apartmentNumber: string
    status: string
    additionalItem: AdditionalItem | null
    marks: any | null
    statusChangedOnWeb: boolean
    minHeight: number
    complimentsNumber: ComplimentsNumber[] | null
    providerId: string
    isRescheduling: boolean
    slots: Slots[]
    chips: String[]
    isJobTimeInfoShown: boolean
    bids: Bid[]
    originatedFrom?: number
}

const initialState: JobDetailsState = {
    address: null,
    jobCategoryId: '',
    jobCategoryName: '',
    msaId: '',
    note: '',
    jobItems: null,
    areItemsOutside: false,
    areItemsInside: false,
    amount: 0,
    isElevatorNeeded: false,
    areStairsNeeded: false,
    jobCategories: [],
    selectedJobCategory: '0',
    subCategories: [],
    attachments: null,
    futureDateFrom: null,
    futureDateTo: null,
    time: {
        time: -1,
        futureTime: -1,
        isFuture: 0,
        minTime: -1
    },
    jobId: '',
    apartmentNumber: '',
    status: '',
    additionalItem: null,
    marks: null,
    statusChangedOnWeb: false,
    minHeight: 50,
    complimentsNumber: null,
    isRescheduling: false,
    slots: [],
    chips: [],
    providerId: '',
    isJobTimeInfoShown: false,
    bids: [],
    originatedFrom: undefined
}

export function jobDetailsReducer(
    state: JobDetailsState = initialState,
    action: JobDetailsActions
) {
    switch (action.type) {
        case constants.ADDRESS:
            return {
                ...state,
                address: action.address
            }
        case constants.COORDINATES:
            return {
                ...state,
                coordinates: action.latLng
            }
        case constants.SELECT_JOB_CATEGORY:
            return {
                ...state,
                jobCategoryId: action.id,
                jobCategoryName: action.name
            }
        case constants.ADD_COMMENT:
            return {
                ...state,
                note: action.note
            }
        case constants.FUTURE_DATE_FROM:
            return {
                ...state,
                futureDateFrom: action.futureDateFrom
            }
        case constants.FUTURE_DATE_TO:
            return {
                ...state,
                futureDateTo: action.futureDateTo
            }
        case constants.JOB_ITEMS:
            return {
                ...state,
                jobItems: action.jobItems
            }
        case constants.ITEMSOUTSIDE:
            return {
                ...state,
                areItemsOutside: action.areItemsOutside
            }
        case constants.ITEMSINSIDE:
            return {
                ...state,
                areItemsInside: action.areItemsInside
            }
        case constants.AMOUNT:
            return {
                ...state,
                amount: action.amount
            }
        case constants.MSAID:
            return {
                ...state,
                msaId: action.msaId
            }
        case constants.IS_ELEVATOR_NEEDED:
            return {
                ...state,
                isElevatorNeeded: action.isElevatorNeeded
            }
        case constants.ARE_STAIRS_NEEDED:
            return {
                ...state,
                areStairsNeeded: action.areStairsNeeded
            }
        case constants.ATTACHMENTS:
            return {
                ...state,
                attachments: action.files
            }
        case constants.JOB_CATEGORIES:
            return {
                ...state,
                jobCategories: action.jobCategories
            }
        case constants.SELECTED_JOB_CATEGORY:
            return {
                ...state,
                selectedJobCategory: action.selectedJobCategory
            }
        case constants.SUB_CATEGORIES:
            return {
                ...state,
                subCategories: action.subCategories
            }
        case constants.TIME:
            return {
                ...state,
                time: action.time
            }
        case constants.JOB_ID:
            return {
                ...state,
                jobId: action.jobId
            }
        case constants.STATUS:
            return {
                ...state,
                status: action.status
            }
        case constants.ORIGINATED_FROM:
            return {
                ...state,
                originatedFrom: action.id
            }
        case constants.REMOVE_JOB_DETAILS:
            return initialState

        case constants.CURRENT_LOCATION:
            return {
                ...state,
                currentLocation: action.currentLocation
            }
        case constants.ZIPCODE:
            return {
                ...state,
                zipCode: action.zipCode
            }
        case constants.ADDITIONAL_ITEM:
            return {
                ...state,
                additionalItem: action.additionalItem
            }
        case constants.TIME_MARKS:
            return {
                ...state,
                marks: action.marks
            }
        case constants.APARTMENT_NUMBER:
            return {
                ...state,
                apartmentNumber: action.apartmentNumber
            }
        case constants.REMOVE_ALL_IMAGES:
            return {
                ...state,
                attachments: initialState.attachments
            }
        case constants.RESET_CHECKBOXES:
            return {
                ...state,
                isElevatorNeeded: false,
                areStairsNeeded: false,
                areItemsInside: false,
                areItemsOutside: false
            }
        case constants.STATUS_CHANGED_ON_WEB:
            return {
                ...state,
                statusChangedOnWeb: true
            }
        case constants.SAVE_TEXTAREA_HEIGHT:
            return {
                ...state,
                minHeight: action.minHeight
            }
        case constants.COMPLIMENTS_NUMBER:
            return {
                ...state,
                complimentsNumber: action.complimentsNumber
            }
        case constants.SET_PROVIDER_ID:
            return {
                ...state,
                providerId: action.providerId
            }
        case constants.RESCHEDULE:
            return {
                ...state,
                isRescheduling: action.isRescheduling
            }
        case constants.SLOTS:
            return {
                ...state,
                slots: action.slots
            }
        case constants.CHIPS:
            return {
                ...state,
                chips: action.chips
            }
        case constants.JOB_TIME_INFO:
            return {
                ...state,
                isJobTimeInfoShown: action.isJobTimeInfoShown
            }

        case constants.SET_BIDS:
            return {
                ...state,
                bids: action.currentBids
            }

        case constants.REPOST_JOB:
            const job: Job = action.job!
            return {
                ...initialState,
                address: job.address,
                jobCategoryId: job.jobCategoryId,
                jobCategoryName: job.jobCategory!.name,
                selectedJobCategory: 0,
                jobCategories: [job.jobCategory],
                msaId: job.msaId,
                note: job.note,
                jobItems: job.jobItems,
                areItemsOutside: job.areItemsOutside,
                areItemsInside: job.areItemsInside,
                isElevatorNeeded: job.isElevatorNeeded,
                areStairsNeeded: job.areStairsNeeded,
                subCategories: job.jobSubCategories,
                attachments: action.attachments!,
                apartmentNumber: job.apartmentNumber,
                jobId: job.id
            }
    }
    return state
}

export interface PublishedJobParamsState {
    hours: number
    minutes: number
    seconds: number
    confirmed: boolean
    createDate: number
    timeKeeping: number
    timeStopBidding: number
    secondTimeKeeping: number
    biddingActiveDate: number
}

const paramsState: PublishedJobParamsState = {
    hours: 0,
    minutes: 0,
    seconds: 0,
    confirmed: false,
    createDate: 0,
    timeKeeping: 0,
    timeStopBidding: 0,
    secondTimeKeeping: 0,
    biddingActiveDate: 0
}

export function publishedJobParamsReducer(
    state: PublishedJobParamsState = paramsState,
    action: PublishedJobParamsAction
) {
    switch (action.type) {
        case constants.PUBLISHED_JOB_PARAMS:
            return {
                ...state,
                hours: action.hours,
                minutes: action.minutes,
                seconds: action.seconds,
                confirmed: action.confirmed,
                createDate: action.createDate,
                timeKeeping: action.timeKeeping,
                timeStopBidding: action.timeStopBidding,
                secondTimeKeeping: action.secondTimeKeeping,
                biddingActiveDate: action.biddingActiveDate
            }
        case constants.REMOVE_JOB_DETAILS:
            return paramsState
    }
    return state
}



// WEBPACK FOOTER //
// ./src/reducers/setJobDetails.ts